export default "__VITE_ASSET__cn$3lJMO__"